import { render, staticRenderFns } from "./OrderFailureDialog.vue?vue&type=template&id=126a72cd&scoped=true&"
import script from "./OrderFailureDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderFailureDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderFailureDialog.vue?vue&type=style&index=0&id=126a72cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a72cd",
  null
  
)

export default component.exports